
// ROUTES
require('modules/notification/routes/notification');

// CONTROLLERS
require('modules/notification/controllers/notification');
require('modules/notification/controllers/list');
require('modules/notification/controllers/create');
require('modules/notification/controllers/edit');
require('modules/notification/controllers/assign');


// SERVICES
require('modules/notification/services/notification');
require('modules/notification/services/list');
require('modules/notification/services/create');
require('modules/notification/services/edit');
require('modules/notification/services/delete');
require('modules/notification/services/assign');
require('modules/notification/services/send');



angular.module('unica_notification', [

	// ROUTES
	'unica_notification.notification_routes',

	// CONTROLLERS
	'unica_notification.notification_controllers',

	// SERVICES
	'unica_notification.notification_services'

]);